module.exports = __webpack_public_path__ + "static/media/smoke.5f331fc2.svg";